<!-- Sliding Panel Container -->
<div class="notification-panel-overlay" 
     *ngIf="isOpen" 
     (click)="closePanel()"
     [@fadeIn]>
</div>

<div class="notification-panel" 
     *ngIf="isOpen" 
     [@slideIn]
     (click)="$event.stopPropagation()">
  
  <!-- Panel Header -->
  <div class="notification-header">
    <h2 class="notification-title">Notification</h2>
    <div class="header-actions">
      <button 
        class="clear-all-btn" 
        (click)="onClearAll()" 
        *ngIf="activeTab === 'triggered' && notifications.length > 0 && !isLoading">
        Clear All
      </button>
      <div class="close-btn" (click)="closePanel()" aria-label="Close panel">
        <div class="close-icon"></div>
      </div>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="tab-navigation">
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'triggered'"
      (click)="switchTab('triggered')">
      Triggered Alerts
    </button>
  </div>

  <!-- Tab Content -->
  <div class="notification-content">
    
    <!-- Loading State -->
    <div class="notification-loading" *ngIf="isLoading">
      <div class="spinner"></div>
      <p class="loading-text">Loading alerts...</p>
    </div>

    <!-- Triggered Alerts Tab -->
    <div class="tab-content" *ngIf="activeTab === 'triggered' && !isLoading">
      
      <!-- Empty State -->
      <div class="notification-empty-state" *ngIf="notifications.length === 0">
        <div class="empty-state-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 8C30.9 8 30 8.9 30 10V11.08C23.84 11.82 19 17.05 19 23.5V36L15 40V42H49V40L45 36V23.5C45 17.05 40.16 11.82 34 11.08V10C34 8.9 33.1 8 32 8ZM32 56C34.21 56 36 54.21 36 52H28C28 54.21 29.79 56 32 56Z" fill="#CCCCCC"/>
          </svg>
        </div>
        <p class="empty-state-text">No new triggered alerts</p>
      </div>

      <!-- Alerts List -->
      <div class="notification-list" *ngIf="notifications.length > 0">
        <div class="notification-item" *ngFor="let notification of notifications; let i = index">
          <!-- <div class="notification-icon"></div> -->

          <div class="notification-icon-container">
            <div class="notification-icon"></div>
          </div>

          <div class="notification-details">
            <div class="alert-header-container">
              <h3 class="notification-alert-name" [attr.title]="notification.header">
                {{ notification.header }}
              </h3>
              <div class="shared-by-email" 
                  *ngIf="notification.sharedBy"
                  [attr.title]="notification.sharedBy">
                ({{ notification.sharedBy }})
              </div>
            </div>
            
            <p class="notification-description" 
              [innerHTML]="getSanitizedHtml(notification.text)"
              [attr.title]="stripHtml(notification.text)">
            </p>
          </div>

          <div class="delete-alert" (click)="deleteAlert(notification, i)" title="Delete alert">
            <div class="deleteIcon"></div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Panel Footer -->
  <div class="notification-footer" *ngIf="!isLoading && notifications.length > 0">
    <p class="footer-text">
      <span *ngIf="totalAlerts > 20">Showing the first 20 alerts.<br></span>
      For more details, check the Alert Management module.
    </p>
    <button class="alert-management-btn" (click)="navigateToAlertManagement()">
      Alert Management
    </button>
  </div>
  
</div>

<app-confirmation-dialog
  *ngIf="showClearAlertConfirmation"
  id="clearAlertConfirmation"
  [messageText]="clearAlertsMessage"
  confirmBtnText="Clear All"
  (confirmed)="onClearConfirmation($event)">
</app-confirmation-dialog>

<!-- <div class="delete-alert-success-message" *ngIf="deleteAlertSuccessMessage">
  <span class="info-icon"></span>
  <span>{{ deleteAlertSuccessMessage }}</span>
</div> -->